import { ProductFormProductIngredient } from "../../../ProductForm.types";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IngredientAccordion } from "./IngredientLine/IngredientAccordion";
import { Fragment } from "react/jsx-runtime";

type IngredientBoxProps = {
    ingredients: ProductFormProductIngredient[];
    setProductIngredients: (newIngredients: ProductFormProductIngredient[]) => void;
};
export const IngredientBox = (props: IngredientBoxProps) => {
    const { ingredients, setProductIngredients } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Fragment>
            <Box
                style={{
                    minHeight: theme.spacing(6),
                    border: `1px solid rgb(231, 230, 228)`,

                    borderRadius: theme.spacing(1),
                    boxShadow: `0px 2px 8px 0px  ${theme.custom.grey[500]}}}`,
                    backgroundColor: "#FEFCFB",

                    display: "grid",
                    alignItems: "center",
                    gridTemplateColumns: "1fr 1fr 1fr",
                }}
            >
                <Box
                    sx={{
                        gridColumn: "1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        paddingInline: theme.spacing(2),
                    }}
                >
                    <Typography variant="body">
                        {t("pages.product.product_form.pages.page2.ingredient_box.ingredient")}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        gridColumn: "2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingInline: theme.spacing(2),
                    }}
                >
                    <Typography variant="body">
                        {t("pages.product.product_form.pages.page2.ingredient_box.quantity_used")}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        gridColumn: "3",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        paddingInline: theme.spacing(2),
                    }}
                >
                    <Typography variant="body">
                        {t("pages.product.product_form.pages.page2.ingredient_box.final_quantity")}
                    </Typography>
                </Box>
            </Box>
            <IngredientAccordion ingredients={ingredients} setProductIngredients={setProductIngredients} />
        </Fragment>
    );
};
